import { render, staticRenderFns } from "./ArticlesCounter.vue?vue&type=template&id=67f3b863&scoped=true"
import script from "./ArticlesCounter.vue?vue&type=script&lang=ts"
export * from "./ArticlesCounter.vue?vue&type=script&lang=ts"
import style0 from "./ArticlesCounter.vue?vue&type=style&index=0&id=67f3b863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3b863",
  null
  
)

export default component.exports